import React, { useState } from 'react';
import { Form, FormGroup, Input, Label, Row } from 'reactstrap';
import "react-datetime/css/react-datetime.css";


export const FormModalDiscountTest = (props) => {

    const {
        handleInputChange, enable_discounts, currentExam,

    } = props;


    return (
        <Form className="pt-3" role="form">
            <Row className='pt-0 form-section'>
                <FormGroup className="mb-2 col-12">

                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>


                        <Label className="col-form-label mb-0">
                            Aplicar descuento al {currentExam?.id_profile ? 'perfil' : 'exámen'}{" "}
                            <strong>{currentExam?.name}</strong>
                        </Label>
                        <Label className="switch mb-0">
                            <Input
                                type="checkbox"
                                name="enable_discounts"
                                onChange={handleInputChange}
                                checked={enable_discounts}
                            />
                            <span className="slider round"></span>
                        </Label>


                    </div>

                </FormGroup>

            </Row>

        </Form>
    )
}


